import { PortableWifiOff } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import { init, send } from "@emailjs/browser";
const Contact = () => {
  const [firstName, setFirstName] = useState("");
  const [surname, setSurname] = useState("");
  const [designation, setDesignation] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [emailError, setEmailError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);



  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  useEffect(() => {
    init("FTAQL3ICrGmk58Zyq"); // Replace with your EmailJS user ID
  }, []);
  const templateParams = {
    firstName,
    surname,
    designation,
    company,
    email,
    subject,
    message,
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!emailRegex.test(email)) {
      setEmailError("Invalid email format. Please enter a valid email.");
      setSuccessMessage("");
      return;
    }

    setEmailError("");
    setIsSubmitting(true);

    // Ensure you include SMTP.js before using window.Email.send()
    if (!window.Email) {
      setEmailError("Email service is unavailable.");
      setIsSubmitting(false);
      return;
    }

    /* window.Email.send({
       Host: "Smtp.gmail.com", // SMTP Host
 
       Username: "sakshishinde9112@gmail.com", // SMTP Email
       Password: "Sakshishinde@66", // WARNING: Move this to the backend
       To: "sakshishinde66@gmail.com",
       From: email,
 
       Subject: subject,
       Body: `Name: ${firstName} ${surname}<br>
              Designation: ${designation}<br>
              Company: ${company}<br>
              Email: ${email}<br>
              Message: ${message}`,
     })
       .then((response) => {
         console.log("Email sent successfully!", response);
         setSuccessMessage("Email sent successfully!");
         resetForm();
       })
       .catch((error) => {
         console.error("Error while sending email:", error);
         setEmailError("Failed to send email. Please try again later.");
       })
       .finally(() => {
         setIsSubmitting(false);
       });*/
    send("service_uv6b075", "template_d54ehqw", templateParams)
      .then((response) => {
        console.log("Email sent successfully!", response.status, response.text);
        setSuccessMessage("Email sent successfully!");
        // resetForm();
      })
      .catch((error) => {
        console.error("Error while sending email:", error);
        setEmailError("Failed to send email. Please try again later.");
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const resetForm = () => {
    setFirstName("");
    setSurname("");
    setDesignation("");
    setCompany("");
    setEmail("");
    setSubject("");
    setMessage("");
    setEmailError("");
  };

  return (
    <div style={{ fontFamily: "Raleway" }}>
      <div className="flex flex-col lg:flex-row w-full min-h-screen">
        <div className="lg:w-1/2 w-full p-8">
          <h1 className="text-3xl font-bold">Contact</h1>
          <div className="mt-6">
            <h2 className="text-xl font-semibold">Visit us</h2>
            <p className="text-gray-700">
              Ecosense Appliances Pvt. Ltd., Flat No. TF-1, 4th Floor, Bhagat
              Residency, Corlim Indust. Estate, Corlim, Goa. 403110
            </p>
          </div>
          <div className="mt-6">
            <h2 className="text-xl font-semibold">Write us at</h2>
            <a
              href="mailto:admin@ecosenseappliances.com"
              className="text-blue-600 hover:underline"
            >
              admin@ecosenseappliances.com
            </a>
          </div>
          <div className="mt-6">
            <h2 className="text-xl font-semibold">Call us</h2>
            <p className="text-gray-700">+91 - 9158890105</p>
          </div>
          <div className="mt-6">
  <h2 className="text-xl font-semibold">Social</h2>
  <div className="flex space-x-4 mt-2">
    <a
      href="https://www.linkedin.com/company/ecosense-appliances-pvt-ltd/"
      target="_blank"
      rel="noopener noreferrer"
      className="text-2xl text-black hover:text-gray-700"
    >
      <i className="fab fa-linkedin"></i>
    </a>

    <a
      href="https://www.instagram.com/_zeropad_?igsh=dzJvOTNyMHZzZ3A3"
      target="_blank"
      rel="noopener noreferrer"
      className="text-2xl text-black hover:text-gray-700"
    >
      <i className="fab fa-instagram"></i>
    </a>

    <a
      href="https://youtube.com/@ecosenseappliances?si=7F1oW0hD8X0w3ka5"
      target="_blank"
      rel="noopener noreferrer"
      className="text-2xl text-black hover:text-gray-700"
    >
      <i className="fab fa-youtube"></i>
    </a>
  </div>
</div>


        </div>

        <div className="lg:w-1/2 w-full p-8 transform -translate-y-12 lg:translate-y-0">
          <h2 className="text-2xl font-bold">Contact Form</h2>
          <p className="text-gray-600">
            Fill the form below for "Partnerships & Collaboration".
          </p>
          <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
            <div className="flex space-x-4">
              <input
                type="text"
                placeholder="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                className="w-1/2 p-3 border rounded bg-gray-200"
              />
              <input
                type="text"
                placeholder="Surname"
                value={surname}
                onChange={(e) => setSurname(e.target.value)}
                className="w-1/2 p-3 border rounded bg-gray-200"
              />
            </div>
            <div className="flex space-x-4">
              <input
                type="text"
                placeholder="Designation"
                value={designation}
                onChange={(e) => setDesignation(e.target.value)}
                className="w-1/2 p-3 border rounded bg-gray-200"
              />
              <input
                type="text"
                placeholder="Company"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                className="w-1/2 p-3 border rounded bg-gray-200"
              />
            </div>
            <div>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full p-3 border rounded bg-gray-200"
              />
            </div>
            <input
              type="text"
              placeholder="Subject..."
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              className="w-full p-3 border rounded bg-gray-200"
            />
            <textarea
              placeholder="Message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="w-full p-3 border rounded h-32 bg-gray-200"
            ></textarea>
            <button
              type="submit"
              className="bg-black text-white px-6 py-2 rounded disabled:opacity-50"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Sending..." : "Submit"}
            </button>
            {emailError && <p className="text-red-500 mt-2">{emailError}</p>}
            {successMessage && (
              <p className="text-green-500 mt-2">{successMessage}</p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
